/**
 * 文の台帳（map）。まとめは ../ui-texts.ts。
 * 管理UIへ写すので、../ui-texts.ts の型の他は何も import しない
 */
import type { UiTextDef } from "../ui-texts";

export const MAP_TEXTS = {
  // 地図そのもの
  "map.canvasAria": { text: "図書館の地図", label: "地図の読み上げの名前", note: "画面には出ない" },
  "map.node.startMark": { text: "始", label: "丸の中の字（はじまりの場所）", note: "傾向の無い場所の丸の中" },
  "map.node.formatMark": { text: "書", label: "丸の中の字（書式の間）", note: "第三層の入口の丸の中" },
  "map.node.glimpsedMark": { text: "？", label: "丸の中の字（霧の先）", note: "まだ姿の見えない場所" },

  "map.sea.name": { text: "霧の海", label: "海の名前", note: "大陸のいちばん引っ込んだ所の沖に薄く出る" },
  "map.region.name": { text: "{属性}領", label: "国の名前", note: "地図の下地に薄く出る。傾向が1つの場所の国だけで、同じ属性の3つの国のうち真ん中の国に1つだけ（組み合わせの国は場所の名前がそのまま国の名前）", vars: "{属性}" },

  // 上の案内板（革の札）
  "map.header.eyebrow": { text: "いまいる場所", label: "上の案内板の小さな見出し" },
  "map.header.current": { text: "{場所}", label: "上の案内板のいまいる場所", vars: "{場所}" },

  // 左下の図面の題
  "map.plan.library": { text: "無限図書館", label: "左下の図面の題（上の行）" },
  "map.plan.floor1": { text: "第一層 平面図", label: "左下の図面の題（第一層）" },
  "map.plan.floor2": { text: "第二層 平面図 ― 組み合わせの回廊", label: "左下の図面の題（第二層）" },
  "map.plan.floor3": { text: "第三層 平面図 ― 書式の間", label: "左下の図面の題（第三層）" },

  // 属性の表（階の切り替えの下）
  "map.legend.heading": { text: "属性", label: "属性の表の見出し", note: "押すと開け閉めする" },
  "map.legend.combo": { text: "二重の輪＝組み合わせ", label: "属性の表のいちばん下の行" },

  // 右の拡大・縮小のボタン
  "map.zoom.inAria": { text: "拡大", label: "「＋」ボタンの読み上げの名前", note: "画面には出ない" },
  "map.zoom.outAria": { text: "縮小", label: "「－」ボタンの読み上げの名前", note: "画面には出ない" },
  "map.zoom.hereAria": { text: "いまいる場所へ", label: "「◎」ボタンの読み上げの名前", note: "画面には出ない" },

  // 選んだ館のシート
  "map.sheet.back": { text: "地図に戻る", label: "館のカードを閉じるボタン", note: "カードのいちばん下の左" },
  "map.sheet.close": { text: "閉じる", label: "シートの × の読み上げの名前", note: "画面には出ない" },
  "map.sheet.glimpsedTitle": { text: "？？？", label: "シートの題（霧の先）", note: "まだ姿の見えない場所を押したとき" },
  "map.sheet.glimpsedSub": { text: "霧の向こう", label: "シートの小さな見出し（霧の先）", note: "まだ姿の見えない場所を押したとき" },
  "map.sheet.glimpsedBody": { text: "何かがあるようです。隣の場所まで道を開くと、姿が見えてきます。", label: "シートの文（霧の先）", note: "まだ姿の見えない場所を押したとき" },
  "map.sheet.subHere": { text: "いまいる場所", label: "シートの小さな見出し（いまいる場所）" },
  "map.sheet.subOpened": { text: "道の通じた場所", label: "シートの小さな見出し（道の通じた場所）" },
  "map.sheet.subReachable": { text: "霧の先（まだ道が無い）", label: "シートの小さな見出し（まだ道が無い場所）" },
  "map.sheet.illustrationAlt": { text: "{場所}のイラスト", label: "場所の絵の読み上げの名前", note: "画面には出ない", vars: "{場所}" },
  "map.sheet.illustrationOpen": { text: "{場所}の絵を大きく見る", label: "場所の小さな絵の読み上げの名前", note: "画面には出ない。押すと絵の全体が画面いっぱいに出る", vars: "{場所}" },
  "map.sheet.weightsEven": { text: "すべての本が、同じ確率で出ます。", label: "出やすい本の行（傾向の無い場所）" },
  "map.sheet.weightsHeading": { text: "ここで本を引くと出る本", label: "出やすい本の見出し", note: "館のカードの背表紙の棚の上" },
  "map.sheet.weightItem": { text: "{属性}の本 {割合}%", label: "出やすい本の札（属性ごと）", note: "途中で折れない札として横に並ぶ", vars: "{属性}・{割合}" },
  "map.sheet.weightRest": { text: "ほかのすべての本 {割合}%", label: "出やすい本の札（残り）", note: "属性の札の後ろに並ぶ", vars: "{割合}" },
  "map.sheet.materialDrop": { text: "読了で落ちる素材：{素材}", label: "読了で落ちる素材の行", vars: "{素材}" },

  // 館で出会える精霊
  "map.spirits.headingDebug": { text: "この場所で初めて読む本を読み終えると出会える精霊（1冊ごとの確率・デバッグ：押すと発見済みに切り替え）", label: "出会える精霊の見出し（デバッグ）", note: "デバッグのときだけ" },
  "map.spirits.odds": { text: "精霊に出会う確率", label: "精霊に出会う確率の名前", note: "後ろに確率（12.3% など）が付く" },
  "map.spirits.guaranteed": { text: "（引いた本・今日の確定）", label: "精霊に出会う確率の確定の印", note: "その日の確定が残っているとき" },
  "map.spirits.unknownAria": { text: "まだ出会っていない精霊", label: "まだ出会っていない精霊の読み上げの名前", note: "画面には出ない" },
  "map.spirits.unknownName": { text: "？？？", label: "まだ出会っていない精霊の名前" },

  // 一致ボーナス
  "map.affinity.heading": { text: "一致ボーナス", label: "一致ボーナスの見出し" },
  "map.affinity.tagMatched": { text: "一致", label: "館の名前の横の札（一致しているとき）", note: "朱の丸い判。押すと一致ボーナスの説明が開く" },
  "map.affinity.tagMatchedSub": { text: "素材が増える", label: "館の名前の横の札の添え字（一致しているとき）" },
  "map.affinity.tagHint": { text: "{属性}の精霊で一致", label: "館の名前の横の札（一致していないとき）", note: "薄い鉛筆の枠。押すと一致ボーナスの説明が開く", vars: "{属性}（「・」でつなぐ）" },
  "map.affinity.noTags": { text: "この場所には傾向が無いので、作風の精霊は一致しません", label: "一致ボーナスの行（傾向の無い場所）" },
  "map.affinity.formatOnly": { text: "書式の場所と一致する精霊は、まだ決めていません", label: "一致ボーナスの行（書式の場所）" },
  "map.affinity.worldAttr": { text: "{属性}は世界の属性なので、場所では一致しません（試作の方向の仮置き）", label: "一致ボーナスの行（世界の属性の場所）", vars: "{属性}" },
  "map.affinity.notMatched": { text: "{属性}の精霊を連れて行くと、{属性}の素材が増えます（量は未定）", label: "一致ボーナスの行（一致する精霊を連れていないとき）", vars: "{属性}" },
  "map.affinity.matched": { text: "{名前}が一致：この場所で読むと、{属性}の素材が増えます（量は未定）", label: "一致ボーナスの行（一致する精霊を連れているとき）", vars: "{名前}（「・」でつなぐ）・{属性}" },

  // 仮のパーティ（デバッグ）
  "map.debug.party": { text: "仮のパーティ（デバッグ）：{精霊}", label: "仮のパーティの行", note: "デバッグのときだけ（手持ちの精霊がいないとき）", vars: "{精霊}（属性を「・」でつなぐ）" },
  "map.debug.partyNone": { text: "なし", label: "仮のパーティの行（だれもいないとき）", note: "デバッグのときだけ" },
  "map.debug.pickerClose": { text: "▴ 閉じる", label: "仮のパーティの行の後ろ（開いているとき）", note: "デバッグのときだけ" },
  "map.debug.pickerOpen": { text: "▾ 変える", label: "仮のパーティの行の後ろ（閉じているとき）", note: "デバッグのときだけ" },
  "map.debug.worldTag": { text: "（世界）", label: "仮のパーティの選び札の世界の印", note: "デバッグのときだけ" },
  "map.debug.spiritName": { text: "仮の{属性}の精霊", label: "仮のパーティの精霊の名前", note: "デバッグのときだけ。一致ボーナスの行に出る", vars: "{属性}" },

  // 階段
  "map.stairs.heading": { text: "階段（開く素材は検討中・今は無料）", label: "階段の見出し", note: "階段のある開いた場所" },
  "map.stairs.go": { text: "{矢印} {階}「{場所}」", label: "階段のボタン", vars: "{矢印}（↑か↓）・{階}・{場所}" },
  "map.stairs.unknown": { text: "？？？", label: "階段のボタンの行き先（霧の先）" },

  // 下のボタン
  "map.move.here": { text: "いまここで本を読んでいます", label: "向かうボタン（いまいる場所）" },
  "map.move.go": { text: "ここへ向かう", label: "向かうボタン" },
  "map.cost.heading": { text: "必要な素材：", label: "道を開く素材の行の頭", note: "館のカードの下の欄。後ろに素材の札（謎の鍵 102/3 など）が並ぶ" },
  "map.cost.any": { text: "どの素材でも（多い順に使う）", label: "道を開く素材（どの素材でもよいとき）" },
  "map.cost.attr": { text: "{属性}の素材", label: "道を開く素材の名前（素材の名前が無い属性）", vars: "{属性}" },
  "map.cost.chip": { text: "{素材} {持っている}/{要る}", label: "道を開く素材の札", vars: "{素材}・{持っている}・{要る}" },
  "map.open.short": { text: "素材が足りません", label: "道を開くボタン（素材が足りないとき）" },
  "map.open.free": { text: "道を開く（素材なし）", label: "道を開くボタン（素材が要らないとき）" },
  "map.open.pay": { text: "素材を使って道を開く", label: "道を開くボタン" },

  // 知らせ（上の案内板の下に出る）
  "map.flash.loadFailed": { text: "進み具合を読み込めませんでした", label: "知らせ（読み込めないとき）" },
  "map.flash.openFailed": { text: "道を開けませんでした", label: "知らせ（道を開けないとき）", note: "サーバーの言葉が無いときだけ" },
  "map.flash.moved": { text: "{場所}へ移りました", label: "知らせ（移ったとき）", vars: "{場所}" },
  "map.flash.movedWithBackground": { text: "{場所}へ移りました（ホームの背景もこの場所の絵に）", label: "知らせ（移ってホームの背景も変わったとき）", vars: "{場所}" },
  "map.flash.moveFailed": { text: "移れませんでした", label: "知らせ（移れないとき）", note: "サーバーの言葉が無いときだけ" },
} as const satisfies Record<string, UiTextDef>;
